export const getRedirectUri = (redirectUri) =>
  `${location.protocol}//${location.hostname}${
    __DEVELOPMENT__ ? `:${location.port}` : ''
  }${redirectUri}`;
